import { Box, Typography } from '@mui/material';
import { useContext } from 'react';
import '../template.module.css';
import { ReportTemplatesContext } from '..';
import { RemoveBlockSVG } from './HelperSVGs';

export function NearestStoresBlock() {
  const { removeBlock } = useContext(ReportTemplatesContext);
  return (
    <Box
      sx={{
        flex: 1,
        backgroundColor: '#F9F9F9',
        paddingY: '1.25rem',
        paddingX: '3.5rem',
        borderRadius: '1rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '.75rem',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '.5rem',
        }}
      >
        <Typography
          sx={{
            fontFamily: 'Lato',
            fontSize: '1.4rem',
            fontWeight: 900,
            lineHeight: '20px',
            textAlign: 'center',
            color: '#39585C',
          }}
        >
          Nearest Stores
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '.5rem',
        }}
      >
        <Typography
          sx={{
            fontFamily: 'Lato',
            fontSize: '1.25rem',
            fontWeight: 500,
            lineHeight: '20px',
          }}
        >
          Walmart
        </Typography>
      </Box>

      <Box
        sx={{
          cursor: 'pointer',
          alignSelf: 'center',
        }}
        onClick={() => {
          removeBlock('Nearest Stores', 'neighborhood');
        }}
      >
        <RemoveBlockSVG />
      </Box>
    </Box>
  );
}
